import * as React from 'react';
import * as _ from 'lodash';
import { Card } from 'react-toolbox/lib/card';
import { CardActions } from 'react-toolbox/lib/card';
import { CardHeader } from 'react-toolbox/lib/card';
import { CardTitle } from 'react-toolbox/lib/card';
import { CardText } from 'react-toolbox/lib/card';
import Button from 'react-toolbox/lib/button';
import { IconButton } from 'react-toolbox/lib/button';
import ProgressBar from 'react-toolbox/lib/progress_bar';
import TextInput from '../../../utils/common_components/textInput_form';
import { Field } from 'redux-form';
import Switch from '../../../utils/common_components/switch_form';
import { Avatar } from 'react-toolbox/lib/avatar';
import Dropzone from 'react-dropzone';
import RichTextEditor from '../../../utils/common_components/rich_text_editor_form';
import { editorConfig } from '../../../utils/common_components/rich_text_editor_form';
import { Dialog } from 'react-toolbox/lib/dialog';
import FontIcon from 'react-toolbox/lib/font_icon';
import TooltipWrapper from '../../../utils/common_components/tooltipWrapper';
import Chip from 'react-toolbox/lib/chip';
import ProgressionView from '../progression_view_new';
import Select from '../../../utils/common_components/tetheredSelect';
import MultiDatePicker from '../../../utils/common_components/multi_date_picker';
export default function () {
    return React.createElement('div', { 'className': 'row m-t-20' }, this.state.showDatePicker ? React.createElement(MultiDatePicker, {
        'active': this.state.showDatePicker,
        'enabledDays': this.props.progression.available_dates,
        'selectedDays': this.props.progression.selected_dates,
        'disableSelection': this.props.disableEditing,
        'onCancel': () => {
            this.finishEditingDays(false);
        },
        'onAccept': selectedDays => {
            this.setState({ updatedDays: selectedDays }, () => {
                this.finishEditingDays(true);
            });
        },
        'key': '1930'
    }) : null, React.createElement('div', { 'className': 'col-xs-12 m-t-20' }, React.createElement('div', { 'className': 'row' }, React.createElement('div', { 'className': 'col-xs-1 bg-white start-xs' }, React.createElement('div', { 'className': 'row center-xs bg-white c-grey p-4' }, React.createElement(FontIcon, {
        'value': 'timer',
        'className': 'f-20'
    }), React.createElement('div', { 'className': 'd-flex m-t-5 f-12' }, React.createElement('span', { 'className': 'm-r-3' }, '\n                            ', this.props.progression.duration, '\n                        '), React.createElement('div', {}, '\n                            mins\n                        '))), React.createElement('div', { 'className': 'row m-t-20' }, React.createElement(Button, {
        'className': 'no-box-shadow progression-btn  c-grey bg-white m-l-8',
        'icon': this.props.disableEditing ? 'pageview' : 'edit',
        'floating': true,
        'ripple': true,
        'mini': true,
        'onClick': this.edit
    })), !this.props.disableEditing ? React.createElement('div', {
        'className': 'row m-t-10',
        'key': '5142'
    }, React.createElement(Button, {
        'className': 'no-box-shadow progression-btn bg-white c-red m-l-8',
        'icon': 'delete_forever',
        'floating': true,
        'ripple': true,
        'mini': true,
        'onClick': this.delete
    })) : null), React.createElement('div', { 'className': 'col-xs-11' }, React.createElement(ProgressionView, {
        'progression': this.props.progression,
        'selectedRole': this.props.selectedRole
    })))));
}